import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort } from "@fortawesome/free-solid-svg-icons";
import * as Styles from "./InboxStyles";

const SortDropdownModal = ({ sorting, setSorting, sortOptions, isMobileView=false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);

  const handleSelect = (value) => {
    setSorting(value);
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY, // Account for scrolling
        left: rect.left + window.scrollX, // Account for scrolling
      });
    }
  }, [isOpen]);

  const dropdown = (
    <div
      style={{
        position: "absolute",
        top: dropdownPosition.top,
        left: dropdownPosition.left-15,
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: "6px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        padding: "4px 0",
        zIndex: 1000000,
        minWidth: "180px",
      }}
    >
      {sortOptions.map((option) => (
        <div
          key={option.value}
          onClick={() => handleSelect(option.value)}
          style={{
            padding: "6px 10px",
            fontSize: "13px",
            cursor: "pointer",
            background: sorting === option.value ? "#f0f8ff" : "#fff",
            color: sorting === option.value ? "#0084FF" : "#333",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#f7f7f7")}
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = sorting === option.value ? "#f0f8ff" : "#fff")
          }
        >
          {option.label}
        </div>
      ))}
    </div>
  );

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {/* Wrap IconButton in a div and attach ref */}
      <div ref={buttonRef} style={{ display: "inline-block" }} >
        <Styles.IconButton
          className=""
          borderless
         
          text={
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <FontAwesomeIcon icon={faSort} style={{ fontSize: "13px", color: isMobileView ? "#343434" : "#f0f8ff" }} />
              {/* <span style={{ fontSize: "13px", color: isMobileView ? "#343434" : "#f0f8ff" }}>
                {sortOptions.find((opt) => opt.value === sorting)?.label}
              </span> */}
            </div>
          }
          data-tooltip-id="inbox-tooltip"
          data-tooltip-content="Select sorting method"
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>

      {/* Render Dropdown in Portal */}
      {isOpen && ReactDOM.createPortal(dropdown, document.body)}
    </div>
  );
};

export default SortDropdownModal;
